import { getMenuData } from "../backend/backend.service";
import { toRaw, ref } from "vue";
import { loadMessages } from "../translation/translation.service";
import _ from "lodash";
export async function getMenu() {
    const userId = localStorage.getItem("userId");
    const elementId = localStorage.getItem("menuId");
  
    const componentId = process.env.VUE_APP_CONTAINER_NAME;
  
    if(componentId === undefined) {
      console.error('missing parameter VUE_APP_CONTAINER_NAME');
      return;
    }
    let navigationFromDatabase = ref([]);
    if(elementId != null) {
      if(elementId != "3127243662392558090") {
    navigationFromDatabase = await getMenuData(
      componentId,
      elementId
    );
  } else {
    navigationFromDatabase = await getMenuData(
      elementId, null
    );
  }
    let menuData = toRaw(navigationFromDatabase.value[0]);
    let translationData = toRaw(navigationFromDatabase.value[1]);
  
    menuData = _.filter(menuData, (menuItem: { subMenu: unknown; pageName: null; title: null; }) => {
        if (menuItem.subMenu) {
          menuItem.subMenu = _.filter(menuItem.subMenu, (subMenuItem: { subMenu: unknown; pageName: null; title: null; }) => {
            if (subMenuItem.subMenu) {
              subMenuItem.subMenu = _.filter(subMenuItem.subMenu, (finalMenuItem: { pageName: null; title: null; }) => {
                return finalMenuItem.pageName !== null && finalMenuItem.title !== null;
              })
            }
            return subMenuItem.pageName !== null && subMenuItem.title !== null;
          })
        }
        return menuItem.pageName !== null && menuItem.title !== null;
    });
  
    translationData = _.filter(translationData, (translationString: null) => {
      return translationString !== null;
    });
  
    await loadMessages(translationData);
  
    //const finalMenu = menuData.concat(commonMenuItems4);
    const finalMenu = menuData;
    
    return finalMenu;
  } else {
    return [];
  }
  }